export const alfred = {
  streaming: { path: `alfred/v1` },
  feedback: { path: 'alfred/v1/feedback' },
};
